var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 24.5L19.4332 19.4332M19.4332 19.4332C20.2999 18.5665 20.9874 17.5375 21.4564 16.4051C21.9255 15.2727 22.1669 14.059 22.1669 12.8333C22.1669 11.6076 21.9255 10.3939 21.4564 9.26153C20.9874 8.12912 20.2999 7.1002 19.4332 6.2335C18.5665 5.36679 17.5375 4.67929 16.4051 4.21023C15.2727 3.74118 14.059 3.49976 12.8333 3.49976C11.6076 3.49976 10.3939 3.74118 9.26153 4.21023C8.12912 4.67929 7.1002 5.36679 6.2335 6.2335C4.48311 7.98388 3.49976 10.3579 3.49976 12.8333C3.49976 15.3087 4.48311 17.6828 6.2335 19.4332C7.98388 21.1835 10.3579 22.1669 12.8333 22.1669C15.3087 22.1669 17.6828 21.1835 19.4332 19.4332Z",
    stroke: "#0C0C0C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.91638acd3af597a4b34eef8803b3b5cf.svg";
export { ForwardRef as ReactComponent };